import { useRef, useState } from "react";
import { IoIosPlayCircle } from "react-icons/io";
import { useHistory, useLocation, Link, useRouteMatch } from "react-router-dom";
import style from "./style.module.scss";

function NewsItem({ order, data }) {
    const [playing, setPlaying] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const vidPlayer = useRef();

    const { url } = useRouteMatch();

    function playVid() {
        vidPlayer.current.play();
        setPlaying(true);
    }

    return (
        <Link to={(data?.video) ? undefined : `${url}/${(data?.path ?? "")}`} style={{ color: "inherit", textDecoration: "inherit" }}>
            <div className={style.news_item} >
                {
                    (data?.video) ?
                        <div className={style.image_box} style={{ order: order }}>
                            {(!playing) && <div className={style.play}>
                                <IoIosPlayCircle onClick={playVid} />
                            </div>}

                            <video ref={vidPlayer} controls src={`${data?.video ?? ""}`} />
                        </div> :
                        <div className={style.image_box} style={{ backgroundImage: `url("${data?.image ?? ""}")`, order: order }}></div>
                }

                <div className={style.text_box}>
                    <div className={style.text}>
                        <div className={style.title}>{data?.title ?? ""}</div>
                        <div className={style.date}>{data?.date ?? ""}</div>
                        {(data?.subtitle != undefined) && <div className={style.subtitle}>{data?.subtitle ?? ""}</div>}
                        {/* Sanitize first! or study and use another method like markdown-jsx <div className={style.text} dangerouslySetInnerHTML={{ __html: (data?.text ?? "") }}></div> */}

                        {(!data?.video) && <div className={style.showmore}>LEES MEER</div>}
                    </div>
                </div>
            </div>
        </Link>
    );
}

export default NewsItem;